/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseCalcFieldToken } from './DatabaseCalcFieldToken';
import {
    DatabaseCalcFieldTokenFromJSON,
    DatabaseCalcFieldTokenFromJSONTyped,
    DatabaseCalcFieldTokenToJSON,
} from './DatabaseCalcFieldToken';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseCalcField
 */
export interface DatabaseCalcField extends DatabaseField {
    /**
     * 
     * @type {Array<DatabaseCalcFieldToken>}
     * @memberof DatabaseCalcField
     */
    formula?: Array<DatabaseCalcFieldToken>;
    /**
     * 
     * @type {string}
     * @memberof DatabaseCalcField
     */
    suffix?: DatabaseCalcFieldSuffixEnum;
    /**
     * 
     * @type {number}
     * @memberof DatabaseCalcField
     */
    precision?: number;
    /**
     * Nichts anzeigen, solange ein Wert der Rechnung FEHLT.
     * 
     * Ohne diese Einstellung faellt ein leeres Bezugsfeld auf 0
     * zurueck — die Rechnung liefert dann eine Zahl, die wie ein
     * Ergebnis aussieht, aber keines ist (eine Summe ohne den halben
     * Beitrag, ein Mittelwert ueber die Haelfte der Werte). Ist der
     * Schalter an, bleibt das Feld leer, bis alle Bezugsfelder
     * gefuellt sind.
     * 
     * Eine 0 gilt als GEFUELLT — sie ist ein Wert. Leer sind nur
     * null, fehlend und die leere Zeichenkette. Konstanten und
     * Kennzahlen aus Unterdatenbanken zaehlen nicht mit.
     * 
     * Vorgabe AUS: bestehende Felder rechnen unveraendert.
     * @type {boolean}
     * @memberof DatabaseCalcField
     */
    hideWhenIncomplete?: boolean;
    /**
     * Nichts anzeigen, wenn KEIN EINZIGES Bezugsfeld gefuellt ist.
     * 
     * Vorgabe des Betreibers 13.10.2026, gemessen an seiner
     * Depot-Uebersicht: Ein „Gesamtwert" summiert die Wertfelder
     * ALLER Rubriken, ein Datensatz traegt aber nur die Felder
     * seiner eigenen. Bei 53 von 69 Eintraegen war die Summe
     * deshalb 0 — und „0,00 EUR" behauptet etwas anderes als
     * „nichts eingetragen".
     * 
     * UNTERSCHIED ZU `hideWhenIncomplete`: Jener Schalter
     * verlangt, dass ALLE Bezugsfelder gefuellt sind — bei einer
     * Summe ueber einander ausschliessende Felder bliebe das Feld
     * dann immer leer. Dieser verlangt nur, dass EINES gefuellt
     * ist: Summe aus nichts ist nichts, Summe aus einem Wert ist
     * dieser Wert.
     * 
     * Eine 0 gilt als GEFUELLT — sie ist ein Wert. Leer sind nur
     * null, fehlend und die leere Zeichenkette. Konstanten und
     * Kennzahlen aus Unterdatenbanken zaehlen nicht mit.
     * 
     * Vorgabe AUS: bestehende Felder rechnen unveraendert.
     * @type {boolean}
     * @memberof DatabaseCalcField
     */
    hideWhenAllEmpty?: boolean;
}


/**
 * @export
 */
export const DatabaseCalcFieldSuffixEnum = {
    Usd: 'USD',
    Eur: 'EUR',
    Gbp: 'GBP',
    Percent: 'PERCENT',
    None: 'NONE'
} as const;
export type DatabaseCalcFieldSuffixEnum = typeof DatabaseCalcFieldSuffixEnum[keyof typeof DatabaseCalcFieldSuffixEnum];


/**
 * Check if a given object implements the DatabaseCalcField interface.
 */
export function instanceOfDatabaseCalcField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseCalcFieldFromJSON(json: any): DatabaseCalcField {
    return DatabaseCalcFieldFromJSONTyped(json, false);
}

export function DatabaseCalcFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseCalcField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'formula': !exists(json, 'formula') ? undefined : ((json['formula'] as Array<any>).map(DatabaseCalcFieldTokenFromJSON)),
        'suffix': !exists(json, 'suffix') ? undefined : json['suffix'],
        'precision': !exists(json, 'precision') ? undefined : json['precision'],
        'hideWhenIncomplete': !exists(json, 'hideWhenIncomplete') ? undefined : json['hideWhenIncomplete'],
        'hideWhenAllEmpty': !exists(json, 'hideWhenAllEmpty') ? undefined : json['hideWhenAllEmpty'],
    };
}

export function DatabaseCalcFieldToJSON(value?: DatabaseCalcField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'formula': value.formula === undefined ? undefined : ((value.formula as Array<any>).map(DatabaseCalcFieldTokenToJSON)),
        'suffix': value.suffix,
        'precision': value.precision,
        'hideWhenIncomplete': value.hideWhenIncomplete,
        'hideWhenAllEmpty': value.hideWhenAllEmpty,
    };
}

